import React, { useState, useEffect } from "react";
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from "../../firebaseConfig"; 
import "./LoginPage.css";

const LoginPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [showPasswordField, setShowPasswordField] = useState(false);

    const handleContinue = (e) => {
        e.preventDefault();
        if (email.trim() !== "") {
            setShowPasswordField(true);
            setError(""); // Clear previous error
        } else {
            setError("⚠️ Please enter a valid email address.");
        }
    };

    const handleEmailLogin = async (e) => {
        e.preventDefault();
        try {
            await signInWithEmailAndPassword(auth, email, password);
            console.log("User signed in successfully");
        } catch (error) {
            // Removing "Firebase:" from error messages
            const errorMessage = error.message.replace(/^Firebase:\s*/, ""); 
            switch (error.code) {
                case "auth/invalid-email":
                    setError("⚠️ The email address is invalid.");
                    break;
                case "auth/user-not-found":
                    setError("⚠️ No user found with this email.");
                    break;
                case "auth/wrong-password":
                    setError("⚠️ Incorrect password. Please try again.");
                    break;
                case "auth/too-many-requests":
                    setError("⚠️ Too many attempts. Try again later.");
                    break;
                case "auth/invalid-credential":
                    setError("⚠️ Invalid credentials. Please check your input.");
                    break;
                default:
                    setError(`⚠️ ${errorMessage}`);
            }
        }
    };

    const handleGoogleLogin = async () => {
        try {
            await signInWithPopup(auth, new GoogleAuthProvider());
            console.log("User signed in with Google");
        } catch (error) {
            const errorMessage = error.message.replace(/^Firebase:\s*/, ""); 
            setError(`⚠️ ${errorMessage}`);
        }
    };

    const handleSSOLogin = async () => {
        // Implement your SSO login logic here
        console.log("SSO login clicked");
        // Example: Redirect to SSO provider's login page
        window.location.href = "https://your-sso-provider.com/login";
    };

    useEffect(() => {
        const unregisterAuthObserver = auth.onAuthStateChanged((user) => {
            if (user) console.log("User signed in:", user);
        });
        return () => unregisterAuthObserver();
    }, []);

    return (
        <div className="login-container">
            <h1 className="login-company-title">Cycle IT</h1>
            <div className="login-box">
                <h1 className="login-title">Sign In</h1>

                {/* Email Form */}
                <form className="login-form" onSubmit={showPasswordField ? handleEmailLogin : handleContinue}>
                    <label htmlFor="email" className="input-label">Email</label>
                    <input
                        id="email"
                        type="email"
                        placeholder="name@example.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    
                    {/* Password Field - Conditional */}
                    {showPasswordField && (
                        <>
                            <label htmlFor="password" className="input-label">Password</label>
                            <input
                                id="password"
                                type="password"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button type="submit" className="primary-button">Sign In</button>
                        </>
                    )}

                    {/* Continue Button */}
                    {!showPasswordField && (
                        <button type="submit" className="primary-button">Continue</button>
                    )}
                </form>

                {/* OR Separator */}
                <div className="separator">
                    <span>OR SIGN IN WITH</span>
                </div>

                {/* Social Login Buttons */}
                <div className="social-login-buttons">
                    <button className="google-button" onClick={handleGoogleLogin}>
                        <img src="https://www.svgrepo.com/show/303108/google-icon-logo.svg" alt="Google Logo" className="google-icon" />
                        Google
                    </button>
                    <button className="sso-button" onClick={handleSSOLogin}>
                        <img src="https://www.svgrepo.com/show/354202/sso.svg" alt="SSO Logo" className="sso-icon" />
                        SSO
                    </button>
                </div>

                {/* Custom Error Alerts */}
                {error && <p className="error-message">{error}</p>}
            </div>
        </div>
    );
};

export default LoginPage;